import { authHeader } from '../../../../helpers/auth-header';
import { client } from '../../../../actions';
import { documentListConstants } from '../../constants/document-list.constants';
import moment from 'moment';
import { requestsConstants } from '../../../Requests/requests.constants';

const url = '/docs';

const documentListActions = {
	setPageSize,
	setSelected,
	deleteDocument,
};

function deleteDocument(doc) {
	if(!doc) return
	
	return (dispatch, getState) => {
		let rurl = url + '/deleteDoc?docId=' + doc
		client.delete(rurl, { headers: authHeader() }).then(            				
				res => { })
		.catch(
				reason => { console.log(reason) } )

		dispatch ({
			type: documentListConstants.DELETE_END,
			payload: 0
		})
	}	
}


function setSelected(val) {
	return dispatch => {
		dispatch({
			type: documentListConstants.SET_SELECTED_ROWS,
			payload: val
		})
	}
}

function setPageSize(val) {
	return dispatch => {
		localStorage.setItem('dspxDocumentsPageSize', JSON.stringify(val));
		dispatch({
			type: documentListConstants.SET_PAGE_SIZE,
			payload: val
		})
	}
}

export default documentListActions